export const META_NAME = "Superstash"
export const META_TAGLINE = "The Easiest Way to Build a Directory Website"
export const META_DESCRIPTION =
  "Collect your content, organize it into collections, and launch a professional directory website effortlessly with Superstash."
